import { Segmented } from 'antd';

/**
 * Three fixed options rendered as a segmented control — one tap, no dropdown
 * ceremony. Contracts use `male | female | other` lowercase, so the widget
 * commits lowercase even though the label is title-case.
 */
export type Gender = 'male' | 'female' | 'other';

interface Props {
  value?: Gender;
  onChange?: (value: Gender) => void;
  disabled?: boolean;
}

const options = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
] as const;

export function GenderField({ value, onChange, disabled }: Props) {
  return (
    <Segmented
      block
      options={options as unknown as { value: string; label: string }[]}
      value={value}
      onChange={(v) => onChange?.(v as Gender)}
      disabled={disabled}
    />
  );
}
